// src/api.js
import axios from "axios";

/**
 * BASE de la API:
 * - Producción: defínela en .env.production como REACT_APP_API_URL=https://fit.gzycode.com/api
 * - Fallback: usa el mismo origen + /api
 */
export const API_BASE =
  process.env.REACT_APP_API_URL || `${window.location.origin}/api`;

/**
 * Instancia principal
 */
const api = axios.create({ baseURL: API_BASE });

/**
 * Reescritura GLOBAL de URLs absolutas a localhost:8000
 */
const LOCAL_RE = /^https?:\/\/(127\.0\.0\.1|localhost):8000/i;

axios.interceptors.request.use((config) => {
  if (typeof config.url === "string" && LOCAL_RE.test(config.url)) {
    config.url = config.url.replace(LOCAL_RE, API_BASE);
  }
  return config;
});

/**
 * Fuerza JSON por defecto en esta instancia (si NO es FormData)
 */
api.defaults.transformRequest = [
  (data, headers) => {
    if (data instanceof FormData) {
      return data;
    }
    headers['Content-Type'] = 'application/json';
    return typeof data === 'string' ? data : JSON.stringify(data);
  },
];

/**
 * Token bearer si existe
 */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Si 401 → limpiar token y forzar login
 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
